exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".practice-team--3bLID-UXNXgHS-YpcLK0-j {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  width: 100%;\n  border-radius: .5rem;\n  background: #d1edf6;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.practice-team--2ddoOLhUE7q29lnEMK5tdN {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-width: 300px;\n}\n\n.practice-team--2ddoOLhUE7q29lnEMK5tdN .buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  margin: 0;\n}\n\n.practice-team--2ddoOLhUE7q29lnEMK5tdN .button:disabled:hover,\n.practice-team--2ddoOLhUE7q29lnEMK5tdN .button:disabled:active {\n  color: #aaa;\n  background: #ccc;\n  text-shadow: none;\n  cursor: not-allowed;\n}\n", ""]);

// exports
exports.locals = {
	"participantFormContainer": "practice-team--3bLID-UXNXgHS-YpcLK0-j",
	"participantFormContainer": "practice-team--3bLID-UXNXgHS-YpcLK0-j",
	"participantFormContainerInner": "practice-team--2ddoOLhUE7q29lnEMK5tdN",
	"participantFormContainerInner": "practice-team--2ddoOLhUE7q29lnEMK5tdN"
};